// // TODO: Remove feature toggle related code in the next version release
// Feature Toggles
export const FEATURE_TOGGLE_ENABLE_BOOSTCONNECT_MANDATE = false;
// Cleanup existing repayment flow on next update once the new version is in production and stable
export const FEATURE_TOGGLE_ENABLE_REPAYMENT_EXISTING_FLOW = false;

export const FEATURE_TOGGLE_ENABLE_JOURNEY_EXISTING_FLOW = false;

export const FEATURE_TOGGLE_BLOCK_TRACKING_GA4 = false;
export const FEATURE_TOGGLE_BLOCK_TRACKING_NETCORE = false;
